import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { combineLatest } from 'rxjs';
import { filter } from 'rxjs/operators';
import { CultureService } from 'src/app/shared/culture/culture.service';
import { DropcartType } from '../../modules/header/components/dropcart/dropcart.component';
import { RootService } from 'src/app/shared/services/root.service';
import { CompanyService } from 'src/app/shared/services/company.service';
import { SitePagesService } from 'src/app/shared/api/site-pages.service';
import { SiteLanguageService } from 'src/app/shared/services/site-language.service';

@Component({
    selector: 'app-main',
    templateUrl: './root.component.html',
    styleUrls: ['./root.component.scss']
})
export class RootComponent{
    headerLayout: 'classic'|'compact';
    dropcartType: DropcartType;
    inserted:boolean = false;
    /** On the seller pages (/sell, /primecommerce, /tools) the shopper header gives way to the seller bar: one thin bar. */
    sellerArea = false;
    /** Menus closed on arrival are drawn in the browser only, so the server's HTML reaches the page text early. */
    readonly isBrowser: boolean;
    constructor(
        @Inject(PLATFORM_ID) platformId: any,
        public route: ActivatedRoute,
        router: Router,
        cultures: CultureService,
        public root:RootService,
        companies: CompanyService,
        pages: SitePagesService,
        // Held here so it exists before the first navigation ends: it writes <html lang>, the server render's too.
        languages: SiteLanguageService
    )
    {
        this.isBrowser = isPlatformBrowser(platformId);
        const isSeller = (url: string) => /^\/(sell|primecommerce|tools)(\/|$)/.test(cultures.bare(url).split(/[?#]/)[0]);
        this.sellerArea = isSeller(router.url);
        router.events.pipe(filter(e => e instanceof NavigationEnd)).subscribe(() => this.sellerArea = isSeller(router.url));
        this.route.data.subscribe(data => {
            this.headerLayout = data.headerLayout;
            this.dropcartType = data.dropcartType || 'dropdown';
        });
        if(this.inserted == false){
            this.root.insertWebsiteSchema();
            // On the server render the company and the facts (how the checkout takes payment) arrive before the page is
            // sent, so the node is in the HTML. Neither ever fails: each gives null instead.
            combineLatest([companies.company$, pages.facts$]).subscribe(([c, facts]) => this.root.insertOrganizationSchema(c, facts));
            this.inserted = true;
        }

    }
}
